var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showRegStepper)?_c('RegStepper'):(_vm.bidsLoaded)?_c('div',[(!_vm.isNoBids)?_c('BidList'):_c('NoBids')],1):(!_vm.canSeeApps)?_c('BidsNotAvailable'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }